import '../sass/images-carousel.scss';

(() => {
    const $imagesCarousels = document.querySelectorAll('.images-carousel');

    if (!$imagesCarousels) return;

    $imagesCarousels.forEach(($imagesCarousel) => {
        const $carousel = $imagesCarousel.querySelector('.images-carousel__carousel');
        const $navigationPrevious = $imagesCarousel.querySelector('.images-carousel__navigation-button--previous');
        const $navigationNext = $imagesCarousel.querySelector('.images-carousel__navigation-button--next');

        const initCarousel = () => {
            if (!$carousel) return;

            new Swiper($carousel, {
                slidesPerView: 'auto',
                navigation: {
                    nextEl: $navigationNext,
                    prevEl: $navigationPrevious,
                },
            });
        };

        initCarousel();
    });
})();
